<template>
  <div class="itinerary-box">
    <div>
      <div class="row">
        <div class="col">
          <span>
            <img
              :src="getLogoUrl(selectedFlight.departureFlight.airLineLogo)"
              alt="Image"
              class="airline-logo"
            />{{ selectedFlight.departureFlight.airLineTitle }} - پرواز رفت
          </span>
        </div>

        <div class="flight-date">
          <span>{{
            selectedFlight.departureFlight.departureDateTimeShamsiText
          }}</span>
        </div>
      </div>

      <div class="flight-detail row">
        <div class="col">
          <div>
            {{ selectedFlight.departureFlight.originIATA }} -
            {{ selectedFlight.departureFlight.departureTime }}
          </div>
          <!-- <div> {{selectedFlight.departureFlight.departureDateTimeShamsiText}}</div> -->
          <div>
            {{ selectedFlight.departureFlight.originCity }} -
            {{ selectedFlight.departureFlight.origin }}
          </div>
        </div>
        <div class="flight-number col">
          <div>پرواز {{ selectedFlight.departureFlight.flightNumber }}</div>
          <div class="flight-itinerary"></div>
        </div>
        <div class="col">
          <div>
            {{ selectedFlight.departureFlight.destinationIATA }} -
            {{ selectedFlight.departureFlight.arrivalTime }}
          </div>
          <!-- <div> {{selectedFlight.departureFlight.arrivalDateTimeShamsiText}}</div> -->
          <div>
            {{ selectedFlight.departureFlight.destinationCity }} -
            {{ selectedFlight.departureFlight.destination }}
          </div>
        </div>

        <!-- <div class="col">
           <div> بار مجاز : 20 کیلوگرم</div>
          <div> قیمت : {{selectedFlight.departure.totalAdultFare | numFormat}}</div>
      </div> -->
      </div>
    </div>

    <div v-if="isTwoWay">
      <hr />
      <div>
        <div class="row">
          <div class="col">
            <span>
              <img
                :src="getLogoUrl(selectedFlight.returnFlight.airLineLogo)"
                alt="Image"
                class="airline-logo"
              />{{ selectedFlight.returnFlight.airLineTitle }} - پرواز برگشت
            </span>
          </div>

          <div class="flight-date">
            <span>{{
              selectedFlight.returnFlight.departureDateTimeShamsiText
            }}</span>
          </div>
        </div>

        <div class="flight-detail row">
          <div class="col">
            <div>
              {{ selectedFlight.returnFlight.originIATA }} -
              {{ selectedFlight.returnFlight.departureTime }}
            </div>
            <!-- <div> {{selectedFlight.returnFlight.departureDateTimeShamsiText}}</div> -->
            <div>
              {{ selectedFlight.returnFlight.originCity }} -
              {{ selectedFlight.returnFlight.origin }}
            </div>
          </div>
          <div class="flight-number col">
            <div>پرواز {{ selectedFlight.returnFlight.flightNumber }}</div>
            <div class="flight-itinerary"></div>
          </div>
          <div class="col">
            <div>
              {{ selectedFlight.returnFlight.destinationIATA }} -
              {{ selectedFlight.returnFlight.arrivalTime }}
            </div>
            <!-- <div> {{selectedFlight.returnFlight.arrivalDateTimeShamsiText}}</div> -->
            <div>
              {{ selectedFlight.returnFlight.destinationCity }} -
              {{ selectedFlight.returnFlight.destination }}
            </div>
          </div>         
      <div class="col">
           <div> بار مجاز : 20 کیلوگرم</div>
          <div> قیمت : {{selectedFlight.return.totalAdultFare | numFormat}}</div>
      </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PDKSelectedFlight",
  props: { selectedFlight: {}, isTwoWay: { type: Boolean, default: true } },
  data() {
    return {};
  },
  methods: {
    getLogoUrl(name) {
      return "../img/airlines/" + name + ".png";
    },
  },
  computed: {},
};
</script>

<style>
.flight-number {
  text-align: center;
}
.flight-itinerary {
  position: relative;
  width: 100%;
  border: 1px solid #14012a;
  height: 1px;
  display: flex;
  justify-content: space-evenly;
  margin-top: 10px;
}

.flight-itinerary::before {
  width: 7px;
  height: 7px;
  background: #14012a;
  content: "";
  position: absolute;
  border-radius: 50%;
  right: -4px;
  top: -3px;
}

.flight-itinerary::after {
  width: 7px;
  height: 7px;
  background: #14012a;
  content: "";
  position: absolute;
  border-radius: 50%;
  left: -4px;
  top: -3px;
}
.itinerary-box {
  min-height: 278px;
  padding: 20px;
  position: relative;
  background: #fff;
  margin-bottom: 30px;
  color: #333;
    box-shadow: 0 0 15px 0 rgba(0,0,0,0.1);
    border-radius: 15px;
}

.airline-logo {
  position: relative !important;
  left: 0% !important;
  width: 32px;
  margin-top: -8px;
}

.flight-date {
  margin-left: 15px;
}
.flight-detail {
  padding-top: 15px;
  padding-right: 30px;
  padding-left: 30px;
}
.airline-title {
  margin-right: 10px !important;
  margin-top: 4px !important;
}
</style>


